interface CityEventParams {
    name: string
    title: string
    description: string
    cityUrl: string
    archiveUrl: string
    pageTitle: string
}

interface LeaveCityParams {
    archiveUrl: string
    title: string
    description: string
    pageTitle: string
}

const enterCityBreadcrumb = (name: string, archiveUrl: string) => {
    const bc = document.querySelector('.breadcrumb_last')
    if (!bc) return

    // Already on a city — the element before the separator links to the archive
    const prevSep = bc.previousElementSibling
    if (prevSep?.classList.contains('Breadcrumbs-separator') && prevSep.previousElementSibling?.querySelector(`a[href="${archiveUrl}"]`)) {
        bc.textContent = name
        return
    }

    // Base archive — convert last crumb to link and append city
    const sep = document.querySelector('.Breadcrumbs-separator')
    const sepClone = sep?.cloneNode(true)
    const text = bc.textContent || ''

    bc.classList.remove('breadcrumb_last')
    bc.innerHTML = `<a href="${archiveUrl}">${text}</a>`

    if (sepClone) bc.parentNode?.insertBefore(sepClone, bc.nextSibling)

    const crumb = document.createElement('span')
    crumb.className = 'breadcrumb_last'
    crumb.textContent = name

    const after = sepClone ? sepClone.nextSibling : bc.nextSibling
    bc.parentNode?.insertBefore(crumb, after)
}

const leaveCityBreadcrumb = () => {
    const bc = document.querySelector('.breadcrumb_last')
    if (!bc) return

    const sep = bc.previousElementSibling
    if (sep?.classList.contains('Breadcrumbs-separator')) sep.remove()

    const newLast = bc.previousElementSibling
    if (newLast) {
        const a = newLast.querySelector('a')
        if (a) {
            newLast.textContent = a.textContent
            newLast.classList.add('breadcrumb_last')
        }
    }

    bc.remove()
}

const updatePageHeader = (title: string, description: string) => {
    const h1 = document.querySelector('.PageHeader-title')
    if (h1) h1.innerHTML = title

    const desc = document.querySelector('.PageHeader-description')
    if (desc) desc.innerHTML = description
}

const initSearch = () => {
    const defaultPageTitle = document.title

    Livewire.on('enter-city', (params: CityEventParams) => {
        queueMicrotask(() => history.replaceState({}, '', params.cityUrl))
        enterCityBreadcrumb(params.name, params.archiveUrl)
        updatePageHeader(params.title, params.description)
        if (params.pageTitle) document.title = params.pageTitle
    })

    Livewire.on('leave-city', (params: LeaveCityParams) => {
        queueMicrotask(() => history.replaceState({}, '', params.archiveUrl + window.location.search))
        leaveCityBreadcrumb()
        updatePageHeader(params.title, params.description)
        document.title = params.pageTitle || defaultPageTitle
    })

    Alpine.data('search', () => ({
        isLoading: false,
        noResults: false,
        searchQuery: '',
        searchResults: [],
        init() {
            const urlQuery = new URLSearchParams(window.location.search)
            if (urlQuery.has('souradnice')) {
                this.searchQuery = localStorage.getItem(urlQuery.get('souradnice'))
            }

            if (!this.searchQuery) {
                const cityName = (Livewire as any)?.first()?.cityName
                if (cityName) this.searchQuery = cityName
            }

            window.addEventListener("handleLocationSuggestions", (e: CustomEvent) => {
                this.searchResults = e.detail?.suggestions ?? []
                this.noResults = !this.searchResults.length
                this.isLoading = false
            })

            window.addEventListener("setLocationSearchQuery", (e: CustomEvent) => {
                this.clearResults(e.detail?.locality ?? '')
            })

            Livewire.on('change-map', (params: { type: string }) => {
                params.type !== 'lokality' && this.clearResults()
            })

            Livewire.on('enter-city', (params: CityEventParams) => {
                this.clearResults(params.name)
            })

            Livewire.on('leave-city', () => {
                this.clearResults()
            })
        },
        getSearchOptions() {
            if (this.searchQuery === '') {
                this.clearResults()
                return
            }

            if (this.searchQuery.length < 2) return

            this.isLoading = true
            window.dispatchEvent(new CustomEvent("getLocationSuggestions", { detail: { search: this.searchQuery }}));
        },
        clearResults(query = '') {
            this.searchQuery = query
            this.searchResults = []
            this.noResults = false
        },
        selectTerm(index: number) {
            const placePrediction = this.searchResults[index];
            window.dispatchEvent(new CustomEvent("selectLocationSuggestions", { detail: { placePrediction: index }}));
            this.clearResults(placePrediction);
        },
        formatLabel(label: string) {
            const regexp = new RegExp(`${this.searchQuery}`, 'i')
            return label?.replace(regexp, '<b>$&</b>') ?? ''
        }
    }))
}

export default initSearch
